import { render } from "./RoleMenu.vue?vue&type=template&id=dd469a60&scoped=true"
import script from "./RoleMenu.vue?vue&type=script&lang=js"
export * from "./RoleMenu.vue?vue&type=script&lang=js"

import "./RoleMenu.vue?vue&type=style&index=0&id=dd469a60&scoped=true&lang=scss"

import exportComponent from "D:\\programs\\guocode-legacy\\guocodeadmin-vue\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dd469a60"]])

export default __exports__